import React, { Fragment, useState, useEffect } from "react";
import Navbar from "../../components/Navbar";
import PageTitle from "../../components/pagetitle";
import Scrollbar from "../../components/scrollbar";
import { useParams } from "react-router-dom";
import Services from "../../api/service";
import { Link } from "react-router-dom";
import Benefits from "./benefits";
import ServiceSidebar from "./sidebar";
import Logo from "../../images/logo.png";
import Footer from "../../components/footer";
import Image from "../../components/Image/image";

const SeviceSinglePage = (props) => {
	const { id } = useParams();
	//for winter camp page, id is 18

	const serviceDetails = Services.find((item) => item.id === id);

	const ClickHandler = () => {
		window.scrollTo(10, 0);
	};

	return (
		<Fragment>
			<Navbar Logo={Logo} />
			<PageTitle
				pageTitle={serviceDetails.title}
				pagesub={serviceDetails.title}
			/>
			<section className="wpo-service-single-section section-padding">
				<div className="container">
					<div className="row">
						<div className="col-lg-8 col-md-12">
							<div className="wpo-service-single-wrap">
								<div className="wpo-service-single-img">
									<Image src={serviceDetails.simg1} border={true} zoom={false}></Image>
								</div>
								
								<div className="wpo-service-single-content">
									<div className="wpo-service-single-content-des">
										<h2>{serviceDetails.title}</h2>
										{/* <p>{serviceDetails.description}</p> */}
										<p>{serviceDetails.longDescription}</p>
										{serviceDetails.title === "Youth Camps" && (
											<div>
												<div className="row justify-content-center">
													{Services.slice(16, 19).map((service, sitem) => (
														<div
															className="col col-xl-4 col-lg-4 col-sm-6 col-12"
															key={sitem}
														>
															<div className="wpo-features-item-camp">
																{/* Title in place of the icon */}
																{/* Clickable Image below the title */}
																<Link
																	onClick={ClickHandler}
																	to={`/${service.id}`}
																>
																	<h2>{service.title}</h2>
																</Link>
																<Link
																	onClick={ClickHandler}
																	to={`/service-single/${service.id}`}
																>
																	<div className="wpo-features-image">
																		<img
																			src={service.image}
																			alt={service.title}
																			className="service-image"
																		/>
																	</div>
																</Link>
															</div>
														</div>
													))}
												</div>
											</div>
										)}										

										<div className="wpo-service-single-sub-img">
											<ul>
												<li>
													<Image src={serviceDetails.simg2} border={true} zoom={true}></Image>
												</li>
												<li>
													<Image src={serviceDetails.simg3} border={true} zoom={true}></Image>
												</li>
											</ul>
										</div>
									</div>
								</div>
								{/* <div className="wpo-solutions-section">
									<h2>solutions Service</h2>
									<div className="row">
										{Services.slice(0, 3).map((service, Sitem) => (
											<div className="col-lg-4 col-md-6 col-12" key={Sitem}>
												<div className="wpo-solutions-item">
													<div className="wpo-solutions-icon">
														<div className="icon">
															<i className={`fi ${service.fIcon1}`}></i>
														</div>
													</div>
													<div className="wpo-solutions-text">
														<h2>
															<Link
																onClick={ClickHandler}
																to={`/service-single/${service.id}`}
															>
																{service.title}
															</Link>
														</h2>
														<p>
															The lower-numbered purposes are better understood
															and practiced{" "}
														</p>
													</div>
												</div>
											</div>
										))}
									</div>
								</div> */}
								{/* <Benefits/> */}
							</div>
							
						</div>
						{/* <ServiceSidebar /> */}
					</div>
				</div>
			</section>
			<Footer />
			<Scrollbar />
		</Fragment>
	);
};
export default SeviceSinglePage;
